import React, { useState, useContext } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import colors from "../../config/colors";
import NtActivityIndicator from "../../components/NtActivityIndicator";
import UserContext from "../../context/UserContext";
import NtModalUnactiveButton from "../../components/NtModalUnactiveButton";
import NtModalActiveButton from "../../components/NtModalActiveButton";
import { parseError } from "@ntconnect/framework/pbx";
import NtModalError from "../../components/NtModalError";
import NtModalInputField from "../../components/NtModalInputField";
import { createUser } from "../../api/user";
import Logger from "../../common/utils/Logger";
import NtModalTitle from "../../components/NtModalTitle";
import NtModalSubtitle from "../../components/NtModalSubtitle";

function NtUserNewForm({ onCancel, onCreate }) {
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const context = useContext(UserContext);

  const isRequiredFields = () => {
    return name && username && password && email;
  };

  const handleCreate = async () => {
    if (!isRequiredFields()) {
      return;
    }

    setLoading(true);

    const params = {
      name: name,
      username: username,
      password: password,
      email: email,
    };

    const response = await createUser(
      context.user?.domain,
      params
    );

    setError(null);

    Logger("Finished creating the user", response);
    if (response.ok) {
      if (onCreate) {
        onCreate();
      }
    } else {
      setError(parseError(response));
    }

    setLoading(false);
  };

  return (
    <View style={styles.container}>
      <NtModalTitle>Add new User</NtModalTitle>
      <NtModalSubtitle style={[{ marginTop: 4 }]}>
        Use this to configure Users.
      </NtModalSubtitle>

      <NtModalInputField
        containerStyle={{ marginTop: 25 }}
        title={"Name *"}
        placeholder={"Name *"}
        value={name}
        setValue={setName}
      />

      <NtModalInputField
        containerStyle={{ marginTop: 15 }}
        title={"Username *"}
        placeholder={"Username *"}
        value={username}
        setValue={setUsername}
      />

      <NtModalInputField
        containerStyle={{ marginTop: 15 }}
        title={"Password *"}
        placeholder={"Password *"}
        value={password}
        setValue={setPassword}
      />

      <NtModalInputField
        containerStyle={{ marginTop: 15 }}
        title={"Email *"}
        placeholder={"Email *"}
        value={email}
        setValue={setEmail}
      />

      <NtModalError error={error} containerStyle={{ marginTop: 6 }} />

      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          marginTop: 25,
        }}
      >
        {loading && (
          <NtActivityIndicator
            color={colors.blue}
            size="small"
            containerStyle={{ marginRight: 25 }}
          />
        )}
        <NtModalUnactiveButton title={"Cancel"} onPress={onCancel} />
        <NtModalActiveButton
          containerStyle={{ marginLeft: 15 }}
          title={"Create"}
          onPress={() => {
            if (isRequiredFields()) {
              handleCreate();
            }
          }}
          enabled={isRequiredFields()}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minWidth: 500,
    maxWidth: 600,
    padding: 15,
  },
  cancelButton: {
    borderRadius: 4,
    borderWidth: 1,
    borderColor: colors.darkest,
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 4,
    paddingBottom: 4,
  },
  addButton: {
    borderRadius: 4,
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 4,
    paddingBottom: 4,
    backgroundColor: colors.lighGray,
  },
  inputTitle: {
    fontSize: 14,
    fontWeight: "500",
    color: colors.darker,
  },
  input: {
    paddingLeft: 10,
    paddingRight: 10,
    height: 45,
    backgroundColor: colors.lighestGray,
    borderRadius: 8,
  },
});

export default NtUserNewForm;
